







































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";


export interface Data {
  errorKind: string
  errors: string[]
}

export default defineComponent({
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errorKind: null,
      errors: [],
    });

    const onSubmit = async () => {
      window.location.href = `/api/classroom_sessions/authorize_sso?type=sso_digital_paper`;
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));

      if(context.root.$route.query.errorKind){
        state.errorKind = context.root.$route.query.errorKind as string;
      }
    });

    return {
      ...toRefs(state),
      onSubmit,
    }
  }
});
